import * as THREE from "three";
import Experience from "../Experience.js";

export default class Environment {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.ambientLightStatus = true;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("environment");
    }

    this.setRoomLight();
    this.setAmbientLight();
  }


  toggleAmbientLight(){
    if(this.ambientLightStatus){
      this.ambientLight.intensity = 0
      this.ambientLightStatus = false
    } else {
      this.ambientLight.intensity = 1.2
      this.ambientLightStatus = true

    }
  }

  setRoomLight() {
    this.roomLight = new THREE.PointLight("#FCFDC3", 2, 7);
    this.roomLight.shadow.mapSize.set(2048, 2048);
    this.roomLight.shadow.radius = 10;
    this.roomLight.castShadow = true;

    this.roomLight.shadow.camera.far = 2;
    this.roomLight.shadow.normalBias = 0.05;
    this.roomLight.position.set(0, 1, 4);
    this.scene.add(this.roomLight);

    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.roomLight, "intensity")
        .name("roomLightIntensity")
        .min(0)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.roomLight, "distance")
        .name("roomLightDistance")
        .min(0)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.roomLight.position, "x")
        .name("roomLightX")
        .min(-10)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.roomLight.position, "y")
        .name("roomLightY")
        .min(-10)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.roomLight.position, "z")
        .name("roomLightZ")
        .min(-10)
        .max(10)
        .step(0.1);
    }
  }

  setAmbientLight() {
    this.ambientLight = new THREE.PointLight("#FCFDC3", 1.2, 10);
    this.scene.add(this.ambientLight);

    // Debug
    if (this.debug.active) {
      this.debugFolder
        .add(this.ambientLight, "intensity")
        .name("ambientLightIntensity")
        .min(0)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.ambientLight.position, "x")
        .name("ambientLightX")
        .min(-10)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.ambientLight.position, "y")
        .name("ambientLightY")
        .min(-10)
        .max(10)
        .step(0.1);

      this.debugFolder
        .add(this.ambientLight.position, "z")
        .name("ambientLightZ")
        .min(-10)
        .max(10)
        .step(0.1);
    }
  }
}
